// menuConfig.js

const getMenuItems = (can) => {
    if (typeof can !== 'function') return [];
    const customers = {
        path: '/customers', icon: 'fas fa-users', title: 'Customers',
        children: [
            can('get_customers') && { path: '/customers/customers-info', title: 'Customers Information' },
            can('view_customerticket') && { path: '/customers/customers-tickets', title: 'Customers Tickets' },
        ].filter(Boolean)
    };

    const campaigns = {
        path: '/campaigns', icon: 'fas fa-bullhorn', title: 'Campaigns',
        children: [
            can('get_campaigns') && { path: '/campaigns/campaigns-info', title: 'Campaigns Info' },
            can('view_campaign_loa') && { path: '/campaigns/campaigns-loa', title: 'Campaigns LOA' },
            can('view_campaigntype') && { path: '/campaigns/campaigns-types', title: 'Campaigns Types' },
            can('view_campaignkeyword') && { path: '/campaigns/campaigns-keywords', title: 'Campaigns Keywords' },
            can('view_search_engine_keywords_campaign') && { path: '/campaigns/campaigns-search-engine-keywords', title: 'Search Engine Keywords' },
        ].filter(Boolean)
    };

    const domains = {
        path: '/domains', icon: 'fas fa-globe', title: 'Domains',
        children: [
            can('get_domains') && { path: '/domains/domains-info', title: 'Domains Info' },
            can('view_domaincategory') && { path: '/domains/domains-categories', title: 'Domain Categories' },
            can('view_ignoredomain') && { path: '/domains/iframe-ignore-domains', title: 'Iframe Ignore Domains' },
            can('add_Domains_Bulk_Insertion') && { path: '/domains/bulk-domains-insertion', title: 'Bulk Domains Insertion' },
            can('add_Domains_Bulk_Update') && { path: '/domains/bulk-domains-update', title: 'Bulk Domains Update' },
            can('add_Domain_Reporting_Method_Bulk_Update') && { path: '/domains/bulk-update-reporting-method', title: 'Bulk Update Domains Reporting Method' },
            can('view_vrdmessage') && { path: '/domains/vrd-messages', title: 'VRD Messages' },
        ].filter(Boolean)
    };

    const blocking = {
        path: '/blocking', icon: 'fas fa-shield-alt', title: 'Blocking Domains',
        children: [
            can('view_blockingdomain') && { path: '/blocking/blocking-domains', title: 'Blocking Domains' },
            can('view_blockingdomaincategory') && { path: '/blocking/blocking-domain-category', title: 'Blocking Domain Category' },
            can('view_blockingdomainactivity') && { path: '/blocking/blocking-domain-activity', title: 'Blocking Domain Activity' },
        ].filter(Boolean)
    };

    const linkInsertion = can('add_Links_Insertion') && {
        path: "/link-insertion", icon: 'fas fa-link', title: 'Links Insertion',
        children: [
            { path: '/link-insertion/google', title: 'Google' },
            { path: '/link-insertion/bing', title: 'Bing' },
            { path: '/link-insertion/cyberlocker', title: 'Cyberlocker' },
            { path: '/link-insertion/telegram', title: 'Telegram' },
            { path: '/link-insertion/tubes', title: 'Tubes' },
        ]
    };

    const linkMarking = can('mark_Links_Insertion') && {
        path: "/link-marking", icon: 'fas fa-tag', title: 'Links Marking',
        children: [
            { path: '/link-marking/google', title: 'Google' },
            { path: '/link-marking/bing', title: 'Bing' },
            { path: '/link-marking/cyberlocker', title: 'Cyberlocker' },
            { path: '/link-marking/telegram', title: 'Telegram' },
            { path: '/link-marking/tubes', title: 'Tubes' },
            { path: '/link-marking/ugc-episode', title: 'UGC Episode' },
        ]
    };

    const updateLinks = can('update_Links_Insertion') && {
        path: "/update-links", icon: 'fas fa-arrows-alt', title: 'Update Links', children: [
            { path: '/update-links/change-links-status', title: 'Change Links Status' },
            { path: '/update-links/change-links-campaign', title: 'Change Links Campaign' },
            { path: '/update-links/change-removal-status', title: 'Change Removal Status' },
        ]
    };

    const inquiries = can('view_links_info') && {
        path: "/inquiries", icon: 'fas fa-search', title: 'Inquiries', children: [
            { path: '/inquiries/get-links-details', title: 'Get Links Details' },
        ]
    };

    const services = {
        path: "/services", icon: 'fas fa-server', title: 'Services',
        children: [
            can('view_service') && { path: '/services/services-info', title: 'Services Info' },
            can('view_servicecategory') && { path: '/services/services-categories', title: 'Services Categories' },
        ].filter(Boolean)
    };

    const ipIsp = {
        path: "/ip-isp", icon: 'fas fa-sitemap', title: 'IP | ISP Info',
        children: [
            can('view_ipaddress') && { path: '/ip-isp/ip-address', title: 'IP Address' },
            can('view_isp') && { path: '/ip-isp/isp', title: 'ISP' },
        ].filter(Boolean)
    };

    const apps = {
        path: "/apps", icon: 'fas fa-mobile-alt', title: 'Apps',
        children: [
            can('view_appstore') && { path: '/apps/stores', title: 'App Stores' },
            can('view_appname') && { path: '/apps/names', title: 'Apps Names' },
            can('view_appstoredata') && { path: '/apps/data', title: 'Apps Data' },
        ].filter(Boolean)
    };

    const iptv = {
        path: "/iptv", icon: 'fas fa-tv', title: 'IPTV STBS | APPS',
        children: [
            can('view_iptv') && { path: '/iptv/iptv-information', title: 'IPTV APP Information' },
            can('view_iptvserver') && { path: '/iptv/iptv-piracy-servers-information', title: 'Piracy Servers Information' },
            can('view_iptvtechnicalreports') && { path: '/iptv/iptv-technical-reports', title: 'Technical Reports' },
        ].filter(Boolean)
    };

    const liveStreaming = {
        path: "/live-streaming", icon: 'fas fa-signal', title: 'Live Streaming',
        children: [
            can('view_m3ufiles') && { path: '/live-streaming/m3u-files', title: 'M3U Files' },
            can('view_m3ukeywords') && { path: '/live-streaming/m3u-keywords', title: 'M3U Keywords' },
            can('view_m3uresponsemessages') && { path: '/live-streaming/m3u-response-messages', title: 'M3U Response Messages' },
        ].filter(Boolean)
    };

    const reviewingScreenshots = can('view_Review_Screenshot') && {
        path: "/reviewing-screenshots", icon: 'fas fa-image', title: 'Reviewing Screenshots', children: [
            { path: '/reviewing-screenshots/tube', title: 'Tube' },
            { path: '/reviewing-screenshots/telegram', title: 'Telegram' },
            { path: '/reviewing-screenshots/search-engine', title: 'Search Engine' },
            { path: '/reviewing-screenshots/ugc-episode', title: 'UGC Episode' },
            { path: '/reviewing-screenshots/ugc-source', title: 'UGC Source' },
            { path: '/reviewing-screenshots/live-streaming', title: 'Live Streaming' },
        ]
    };

    const whitelistChannels = can('view_Tubes_Whitelisting_Channels') && {
        path: '/whitelist-channels', icon: 'fas fa-tv', title: 'Whitelist Channels', children: [
            { path: '/whitelist-channels/tubes-whitelisting-channels', title: 'Tubes Whitelisting Channels' },
        ]
    };

    const opsTasks = {
        path: "/ops-tasks-management", icon: 'fas fa-clipboard', title: 'Ops Task Management',
        children: [
            can('get_task_distribution') && { path: '/ops-tasks-management/distribution-tasks', title: 'Distribution Tasks' },
            can('view_Reviewing_Performance_ops') && { path: '/ops-tasks-management/ops-performance', title: 'Ops Performance' },
        ].filter(Boolean)
    };

    const auth = {
        path: "/auth", icon: 'fas fa-lock', title: 'Auth',
        children: [
            can('view_user') && { path: '/auth/users', title: 'Users' },
            can('view_Customer_Users') && { path: '/auth/customer-users', title: 'Customer Users' },
            can('view_permission') && { path: '/auth/permissions', title: 'Permissions' },
            can('view_group') && { path: '/auth/groups', title: 'Groups' },
        ].filter(Boolean)
    };

    const rdpServers = can('add_guacamole_session') && {
        path: '/rdp-servers', icon: 'fas fa-desktop', title: 'RDP Servers'
    };

    const periodicTasks = (can('django_celery_beat.view_periodictask') || can('view_periodictask')) && {
        path: '/periodic-tasks', icon: 'fas fa-clock', title: 'Periodic Tasks'
    };

    const generateReports = can('Generate_Report') && {
        path: '/generate-reports', icon: 'fas fa-file-alt', title: 'Generate Reports'
    };

    return [
        { is_header: true, title: 'MENU' },
        { path: '/dashboard', icon: 'fas fa-home', title: 'Dashboard' },
        { path: '/general-analytics', icon: 'fas fa-chart-line', title: 'General Analytics' },
        { path: '/campaigns-analytics', icon: 'fas fa-chart-pie', title: 'Campaigns analytics' },
        { path: '/iptv-analytics', icon: 'fas fa-chart-column', title: 'IPTV Analytics' },
        { path: '/live-streaming-analytics', icon: 'fas fa-signal', title: 'Live Streaming Dashboard' },
        { path: '/customer-dashboard', icon: 'fas fa-chart-bar', title: 'Customer Dashboard' },
        { is_divider: true },
        { is_header: true, title: 'APPS' },
        customers.children.length > 0 && customers,
        campaigns.children.length > 0 && campaigns,
        domains.children.length > 0 && domains,
        blocking.children.length > 0 && blocking,
        linkInsertion,
        linkMarking,
        updateLinks,
        inquiries,
        rdpServers,
        services.children.length > 0 && services,
        ipIsp.children.length > 0 && ipIsp,
        apps.children.length > 0 && apps,
        iptv.children.length > 0 && iptv,
        liveStreaming.children.length > 0 && liveStreaming,
        reviewingScreenshots,
        whitelistChannels,
        opsTasks.children.length > 0 && opsTasks,
        auth.children.length > 0 && auth,
        periodicTasks,
        generateReports,
    ].filter(Boolean);
};

export default getMenuItems;
